module.exports = __webpack_public_path__ + "static/media/ba_crest.37460aff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ba_crest.svg
// module id = 847
// module chunks = 0